function getAnnouncementHeight() {
  let mainAnn = document.querySelector('.section-announcement-bar:not(.hide-annouce)');
  let bottomAnn = document.querySelector('.bottom-announcement-bar:not(.hide-annouce)');
  let h = 0;
  if(mainAnn) h += mainAnn.clientHeight || 32;
  if(bottomAnn) h += bottomAnn.clientHeight || 32;
  return h;
}

var lastScroll = 0;
var ticking = false;
var SCROLL_THRESHOLD = 5;
window.addEventListener('scroll', (e) => {
  if (document.body.classList.contains('open-search') || document.body.classList.contains('open-menu')) return;
  if(ticking) return;
  ticking = true;
  window.requestAnimationFrame(function(){
    let scrollCount = window.pageYOffset;
    if(Math.abs(scrollCount - lastScroll) < SCROLL_THRESHOLD){
      ticking = false;
      return;
    }
    let annHeight = getAnnouncementHeight();
    let header = document.querySelector('header').offsetHeight + annHeight;

    if(scrollCount > lastScroll){
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
      if(scrollCount <= header){
        document.querySelector('header').classList.remove('normal-header');
      }else{
        document.querySelector('header').classList.add('normal-header');
      }
      let scrolledHeight = header + 160;
      if(scrollCount >= scrolledHeight) document.querySelector('header').classList.add('animate-header');
    }else if(scrollCount < lastScroll){
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
      if(scrollCount <= (header - annHeight)){
        document.querySelector('header').classList.remove('normal-header');
      }else{
        document.querySelector('header').classList.add('normal-header');
      }
      if(scrollCount <= header) document.querySelector('header').classList.remove('animate-header');
    }
    lastScroll = scrollCount;
    ticking = false;
  })
})
if(document.querySelector('.menu-burger')) document.querySelector('.menu-burger').addEventListener('click',function(e){
  e.preventDefault();
  if(!document.body.classList.contains('open-menu')){
    if(document.body.classList.contains('open-search')){
      document.body.classList.remove('open-search');
      if(window.searchDrawerInstance && typeof window.searchDrawerInstance.close === 'function'){
        window.searchDrawerInstance.close();
      }
    }
  }
  document.body.classList.toggle('open-menu');
  this.setAttribute('aria-expanded', document.body.classList.contains('open-menu') ? 'true' : 'false');
  if(document.body.classList.contains('open-menu')){
    var menuDrawerEl = document.querySelector('.snippet-menu-drawer');
    if(menuDrawerEl){
      menuDrawerEl.inert = false;
      setTimeout(function(){
        var candidates = menuDrawerEl.querySelectorAll('a[href], button:not([disabled])');
        for(var i = 0; i < candidates.length; i++){
          if(candidates[i].getClientRects().length > 0){
            // Initial focus on open shouldn't expand the first nav item's submenu
            skipMegaFocusActivation = true;
            candidates[i].focus();
            skipMegaFocusActivation = false;
            break;
          }
        }
      }, 50);
    }
  }
  if(window.innerWidth >= 992){
    if(document.body.classList.contains('open-menu')){
      document.querySelector('.snippet-menu-drawer').style.height = (document.querySelector('.header').offsetHeight + document.querySelector('.menu-drawer-inner').offsetHeight) + 'px';
    }else{
      document.querySelector('.snippet-menu-drawer').style.height = ''; 
    }
  }
})
var skipMegaFocusActivation = false;
function activateMegaMenuItem(mega_hover) {
  if (window.innerWidth >= 992 && document.body.classList.contains('open-menu')) {
    document.querySelectorAll('.menu-subcategories.hover-submenu').forEach(function (el) {
      if (!mega_hover.contains(el)) {
        el.classList.remove('hover-submenu');
      }
    });
    let subMenu = mega_hover.querySelector('.menu-subcategories');
    let headerHeight = document.querySelector('.header') ? document.querySelector('.header').offsetHeight : 0;
    let innerHeight = document.querySelector('.menu-drawer-inner') ? document.querySelector('.menu-drawer-inner').offsetHeight : 0;
    if(subMenu){
      subMenu.classList.add('hover-submenu');
      let subMenuHeight = subMenu.offsetHeight + 112;
      document.querySelector('.snippet-menu-drawer').style.height = (headerHeight + Math.max(innerHeight, subMenuHeight)) + 'px';
    }else{
      document.querySelector('.snippet-menu-drawer').style.height = (headerHeight + innerHeight) + 'px';
    }
    let menuHandle = mega_hover.querySelector('.menu-nav-link a') ? mega_hover.querySelector('.menu-nav-link a').getAttribute('data-val') : null;
    let hasMatch = false;
    if(menuHandle){
      let matchingElements = document.querySelectorAll('.mega-media-inr[data-val="' + menuHandle + '"]');
      if (matchingElements.length > 0) {
        hasMatch = true;
        document.querySelectorAll('.mega-media-inr').forEach(function (el) {
          el.classList.remove('active-mega');
        });
        matchingElements.forEach(function (el) {
          el.classList.add('active-mega');
        });
      }
    }
    if(!hasMatch){
      document.querySelectorAll('.mega-media-inr').forEach(function(el){
        if(el.getAttribute('data-val') === 'default'){
          el.classList.add('active-mega');
        }else{
          el.classList.remove('active-mega');
        }
      });
    }
  }
}
if (document.querySelectorAll('.mega-menu-hover')) {
  document.querySelectorAll('.mega-menu-hover').forEach(function (mega_hover) {
    mega_hover.addEventListener('mouseenter', function () {
      activateMegaMenuItem(mega_hover);
    });
    // Keyboard parity: opening a top-level item's submenu when focus enters it,
    // so tabbing through the mega menu mirrors the hover experience (WCAG 2.1.1)
    mega_hover.addEventListener('focusin', function () {
      if (skipMegaFocusActivation) return;
      activateMegaMenuItem(mega_hover);
    });
  });
}
document.querySelectorAll('.mega-media-inr').forEach(function(item){
  item.addEventListener('mouseenter', function(){
    const activeBanner = document.querySelector('.mega-media-inr.active-mega');
    if(activeBanner && activeBanner.getAttribute('data-val') != 'default'){
      return;
    }
    document.querySelectorAll('.menu-subcategories.hover-submenu').forEach(function(el){
      el.classList.remove('hover-submenu');
    });
  });
});
document.querySelector('.mega-media')?.addEventListener('mouseenter', function(){
  document.querySelectorAll('.menu-subcategories.hover-submenu').forEach(function(el){
    el.classList.remove('hover-submenu');
  });
});
document.querySelector('.menu-drawer-inner .desk-grid')?.addEventListener('mouseleave',function(){
  if(window.innerWidth >= 992 && document.body.classList.contains('open-menu')){
    document.querySelectorAll('.menu-subcategories.hover-submenu').forEach(function(el){
      el.classList.remove('hover-submenu');
    });
    let headerHeight = document.querySelector('.header') ? document.querySelector('.header').offsetHeight : 0;
    let innerHeight = document.querySelector('.menu-drawer-inner') ? document.querySelector('.menu-drawer-inner').offsetHeight : 0;
    document.querySelector('.snippet-menu-drawer').style.height = (headerHeight + innerHeight) + 'px';
    document.querySelectorAll('.mega-media-inr').forEach(function(el){
      if(el.getAttribute('data-val') === 'default'){
        el.classList.add('active-mega');
      } else {
        el.classList.remove('active-mega');
      }
    });
  }
});
if(document.querySelectorAll('.close-menu')) document.querySelectorAll('.close-menu').forEach(function(closeMenu){
  closeMenu.addEventListener('click',function(e){
    e.preventDefault();
    document.body.classList.remove('open-menu');
    document.querySelectorAll('.menu-subcategories').forEach(function(subMenu){
      subMenu.classList.remove('hover-submenu');
      subMenu.classList.remove('hover-submenu');
    });
  });
});
function isHashUrl(link) {
  if (!link) return false;
  if (link.dataset.isHash === 'true' || link.classList.contains('is-hash-url')) return true;
  const href = link.getAttribute('href');
  if (!href) return true;
  const cleanHref = href.trim();
  return cleanHref === '#' || cleanHref === '/#' || cleanHref === '' || cleanHref === 'javascript:void(0)';
}

function openOrToggleMobileSubmenu(li) {
  if (!li) return;
  let subMenu = li.querySelector('.menu-subcategories');
  if (subMenu) subMenu.classList.toggle('hover-submenu');

  if (window.innerWidth < 992) {
    let menuHandle = li.querySelector('.menu-nav-link a') ? li.querySelector('.menu-nav-link a').getAttribute('data-val') : null;
    let hasMatch = false;
    if (menuHandle) {
      let matchingElements = li.querySelectorAll('.mega-media-inr[data-val="' + menuHandle + '"]');
      if (matchingElements.length > 0) {
        hasMatch = true;
        li.querySelectorAll('.mega-media-inr').forEach(function(el) {
          el.classList.remove('active-mega');
        });
        matchingElements.forEach(function(el) {
          el.classList.add('active-mega');
        });
      }
    }
    if (!hasMatch) {
      li.querySelectorAll('.mega-media-inr').forEach(function(el) {
        if (el.getAttribute('data-val') === 'default') {
          el.classList.add('active-mega');
        } else {
          el.classList.remove('active-mega');
        }
      });
    }
  }
}

if(document.querySelectorAll('.sub-arrow')) document.querySelectorAll('.sub-arrow').forEach(function(arrow){
  arrow.addEventListener('click', function(e){
    e.preventDefault();
    let li = arrow.closest('li');
    openOrToggleMobileSubmenu(li);
  });
});

if(document.querySelectorAll('.menu-nav-link a')) document.querySelectorAll('.menu-nav-link a').forEach(function(link){
  link.addEventListener('click', function(e){
    if (isHashUrl(link)) {
      e.preventDefault();
      if (window.innerWidth < 992) {
        let li = link.closest('li');
        openOrToggleMobileSubmenu(li);
      }
    }
  });
});
if(document.querySelectorAll('.back-arrow')) document.querySelectorAll('.back-arrow').forEach(function(arrow){
  arrow.addEventListener('click', function(e){
    e.preventDefault();
    let subMenu = arrow.closest('.menu-subcategories');
    if(subMenu) {
      subMenu.classList.remove('hover-submenu');
      if (window.innerWidth < 992) {
        subMenu.querySelectorAll('.mega-media-inr').forEach(function(el) {
          if (el.getAttribute('data-val') === 'default') {
            el.classList.add('active-mega');
          } else {
            el.classList.remove('active-mega');
          }
        });
      }
    }
  });
});

// Close the menu with Escape and return focus to the burger button (WCAG 2.1.2)
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape' && document.body.classList.contains('open-menu')){
    document.body.classList.remove('open-menu');
    var burger = document.querySelector('.menu-burger');
    if(burger) burger.focus();
  }
});

// Watch for class changes on body to clean up menu drawer height if 'open-menu' is removed by other scripts
const menuObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'class') {
      const isOpen = document.body.classList.contains('open-menu');
      const burgerBtn = document.querySelector('.menu-burger');
      if (burgerBtn) burgerBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      const menuDrawer = document.querySelector('.snippet-menu-drawer');
      // Keep the closed drawer out of the tab order and away from assistive tech
      if (menuDrawer) menuDrawer.inert = !isOpen;
      if (!isOpen && menuDrawer && menuDrawer.style.height !== '') {
        menuDrawer.style.height = '';
        document.querySelectorAll('.menu-subcategories').forEach(function(subMenu){
          subMenu.classList.remove('hover-submenu');
        });
      }
    }
  });
});
if (document.body) {
  menuObserver.observe(document.body, { attributes: true });
}
// Initial state: drawer starts closed, so remove it from the tab order
(function(){
  const menuDrawer = document.querySelector('.snippet-menu-drawer');
  if (menuDrawer && !document.body.classList.contains('open-menu')) menuDrawer.inert = true;
})();